import produce from 'immer';

import {
  SET_PROGRESS_BAR_VISIBLE,
  SET_PROGRESS_BAR_TOTAL,
  SET_PROGRESS_BAR_PROGRESS,
  SET_PROGRESS_BAR_MESSAGE,
  RESET_PROGRESS_BAR
} from 'shared/actions/types';

const initialState = {
  progressBar: {
    visible: false,
    total: 0,
    progress: 0,
    message: null
  }
}


export default function(state = initialState, action) {
  switch(action.type) {
    case SET_PROGRESS_BAR_VISIBLE:
      return produce(state, draft => {
        draft.progressBar.visible = action.payload;
      });

    case SET_PROGRESS_BAR_TOTAL:
      return produce(state, draft => {
        draft.progressBar.total = action.payload;
      });

    case SET_PROGRESS_BAR_PROGRESS:
      return produce(state, draft => {
        draft.progressBar.progress = action.payload;
      });

    case SET_PROGRESS_BAR_MESSAGE:
      return produce(state, draft => {
        draft.progressBar.message = action.payload;
      });

    case RESET_PROGRESS_BAR:
      return produce(state, draft => {
	draft.progressBar = initialState.progressBar;
      });

    default:
      return state;
  }
}
